import jwt from "jsonwebtoken"
import PropTypes from "prop-types"
import React, { createRef, useEffect, useState } from "react"
import { Col, Dropdown, DropdownMenu, DropdownToggle, Row } from "reactstrap"

const { REACT_APP_PING_INTERVAL } = process.env
//i18n
import { withTranslation } from "react-i18next"
import { getExportNotifications } from "services/exports/calls"

const NotificationDropdown = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)

  const mountRef = createRef(null)
  const [files, setFiles] = useState([])
  // const [countCreated, setCountCreated] = useState(0)
  const [count, setCount] = useState(0)

  const mapStatus = {
    COMPLETED: "Finalizado",
    PROGRESS: "Em progresso",
    FAILED: "Erro",
    CREATED: "Criado",
  }

  const mapTipo = {
    atual: "Personalizado",
    historico: "Portador",
    empresa: "Empresa",
    fabrica: "Fábrica",
    custodia: "Custódia",
    bi: "BI",
    chamados: "Chamados",
    prevencao: "Prevenção",
  }

  useEffect(() => {
    const checkNew = (old, res) => {
      let hasNew = 0
      let countNew = 0
      let countOld = 0
      if (old == res) return
      try {
        res.flatMap(x => {
          if (x.status == "COMPLETED") countNew++
        })
        old.flatMap(x => {
          if (x.status == "COMPLETED") countOld++
        })
      } catch (error) {
        return hasNew
      }

      return countNew - countOld
    }

    const checkNotificationsPoll = async old => {
      if (!mountRef.current) return
      try {
        const res = await getExportNotifications(userId)
        // const count = await checkCountCreated()
        const _new = checkNew(old, res)
        let _old = res
        if (_new > 0) {
          setCount(_new)
        }
        setFiles(res)
        // setCountCreated(count.payload.count)
        setTimeout(() => {
          checkNotificationsPoll(_old)
        }, REACT_APP_PING_INTERVAL || 10000)
      } catch (err) {
        console.log(err)
        setTimeout(() => {
          checkNotificationsPoll()
        }, REACT_APP_PING_INTERVAL || 10000)
      }
    }
    let userId
    if (localStorage.getItem("token")) {
      userId = jwt.decode(localStorage.getItem("token"))?.userId
    } else {
      userId = -1
    }
    mountRef.current = true
    checkNotificationsPoll()
    return () => {
      mountRef.current = false
    }
  }, [])

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon position-relative"
          tag="button"
          id="page-header-notifications-dropdown"
          onClick={() => {
            setCount(0)
          }}
        >
          <i className={`bx bx-bell ${count > 0 ? "bx-tada" : ""}`} />
          {count > 0 && (
            <span className="badge bg-danger rounded-pill">{count}</span>
          )}
        </DropdownToggle>

        {count > 0 && (
          <DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
            <div className="p-3">
              <Row className="align-items-center">
                <Col className="d-flex justify-content-center">
                  <a href="/rastreio/exportacao" className="small">
                    {" "}
                    Ver Relatórios Prontos
                  </a>
                </Col>
              </Row>
            </div>
          </DropdownMenu>
        )}
      </Dropdown>
    </React.Fragment>
  )
}

export default withTranslation()(NotificationDropdown)

NotificationDropdown.propTypes = {
  t: PropTypes.any,
}
